<div style="display: flex; gap: 0.7em">
    <p-button pRipple type="button" (click)="showReceptionNote()" icon="fas fa-note-sticky" *ngIf="data.status === enumStatus.Validated"
              styleClass="p-button-sm p-button-info" pTooltip="Generare nota de receptie" tooltipPosition="left"></p-button>
    <p-button pRipple type="button" (click)="showAddEdit()" icon="fas fa-pencil"
              styleClass="p-button-sm p-button-info" pTooltip="Editare" tooltipPosition="left"></p-button>
    <p-button pRipple type="button" (click)="confirm()" icon="fas fa-trash" styleClass="p-button-sm p-button-danger" pTooltip="Stergere" tooltipPosition="left"></p-button>
</div>
